import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBRydsr3xPcnEqjLegc2a2cfmeZpF6enr0",
  authDomain: "dripset-2022.firebaseapp.com",
  projectId: "dripset-2022",
  storageBucket: "dripset-2022.firebasestorage.app",
  messagingSenderId: "485861413773",
  appId: "1:485861413773:web:e090e9080120153aeea3c4",
  measurementId: "G-MVYT7VMS4W"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
